import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane, Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import { Btn, H4 } from '../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getMasterDataToken } from '../../../Utils/restUtils';
import { getCompanyInvoice, getCompanyInvoices, getCompanyPayment, getCompanyPayments, getShareApi } from '../../../CommonURL';
import { Invoice, Payment } from '../../../Constant';
import { paymentsColumns } from '../../../Data/MockTable/TempData';
import { Link } from "react-router-dom";

const InvoicePayment = (props) => {
    const propsId = props.param;
    const propsId2=props.params;
     const style2 = { width: 85, fontSize: 13, padding: 5 };
    const [PrimarycolorLineTab, setPrimarycolorLineTab] = useState('1');
    const authState = useSelector((state) => state.auth);
    const [invoiceList, setInvoiceList] = useState([]);
    const [paymentslist, setPayments] = useState([])
    const [totalRows, setTotalRows] = useState(0);
    const [totalPaymentRows, setpaymentTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPaymentPage, setPaymentCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const InvoiceColumns = [
        {
            name: <H4>Sl No</H4>,
            selector: row => row.Si,
            sortable: true,
            width:'120px',
            center:true
        },
        {
            name: <H4>Action</H4>,
            selector: row => row.action,
            sortable: true,
            width:'120px'

        },
        {
            name: <H4>Invoice no</H4>,
            selector: (row) => (
            <Link
            to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${row.User_id}&order_id=${row.order_id}`}
            >{row.Invoice}</Link>),
            sortable: true,
            center: true,
           

        },
        // {
        //     name: <H4>Invoice Type</H4>,
        //     selector: row => row.InType,
        //     sortable: true,
        //     wrap: true

        // },
        {
            name: <H4>Billing Date</H4>,
            selector: row => row.BillingDate,
            sortable: true,
            wrap: true,
           
        },
        {
            name: <H4>Total</H4>,
            selector: row => row.Total,
            sortable: true,
            width:'140px'

        },
        {
            name: <H4>Status</H4>,
            selector: row => row.Status,
            sortable: true,
           
            // center: true,
            cell: row => (
                <span
                    className={`badge badge-${row.Status}`}
                >
                    {row.Status}
                </span>
            ),
        }
    ];

    useEffect(() => {
        invoiceData(1); // do not put await here
        paymentsData(1);
    }, []);
    const handlePageChange = page => {
        invoiceData(page);
        setCurrentPage(page);
    };

    const handlePaymentPageChange = page => {
        paymentsData(page);
        setPaymentCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        invoiceData(page, newPerPage);
        paymentsData(page, newPerPage);
        setPerPage(newPerPage);
    };

    const redirectToInvoice = async (data) => {
        
        //  let response = await getMasterDataToken(getShareApi + `?order_id=${data.order_id}`);
        //  if (response.data.status == true) {
        //     const toReciept = `${process.env.PUBLIC_URL}/invoice?order_id=${response.data.data}`;
        //     navigate(toReciept);
        // }
        navigate(`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${data.User_id}&order_id=${data.order_id}`);

    };

    const redirectToReciept = (id) => {
        const toReciept = `${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${id}`;
        navigate(toReciept);
    };


   const invoiceData = async (page, size = perPage) => {
    setLoading(true);

    const res = await getMasterDataToken(getCompanyInvoices + `?company_id=${propsId}&user_id=${propsId2}`);

    // Correct status check
    if (res?.data?.status === true) {

        const list = res?.data?.data?.data || [];  

        setInvoiceList(list?.map((e, index) => ({
            Si: index + 1,
            Invoice: e.invoice_number,
            InType: e.invoice_type,
            BillingDate: e.billing_date,
            Total: `${authState?.currency ?? "$"} ${e.total_amount}`,
            Customer: e.customer_name,
            Status: e.payment_status,
            order_id: e.order_id,
            id: e.id,
            customerid: e.customer_id,
            action: (
                <div>
                    <span>
                        <Btn
                            attrBtn={{
                                style: style2,
                                color: 'primary btn-xs',
                                type: 'button',
                                onClick: () => redirectToInvoice(e)
                            }}
                        >
                            ViewMore
                        </Btn>
                    </span>
                </div>
            )
        })));

        // set total count (if backend sends it)
        setTotalRows(res?.data?.total || 0);
        setLoading(false);
    }
    else if (res?.status >= 400 && res.status <= 405) {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    }
    else if (res?.status >= 500 && res.status <= 505) {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    }
    else {
        navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
};


    const paymentsData = async (page, size = perPage) => {
        setLoading(true)
        const payment_api = await getMasterDataToken(getCompanyPayments + `?company_id=${propsId}&user_id=${propsId2}`);
        
        if (payment_api?.data?.status == true) {
            const paymentData = payment_api?.data?.data?.data;
            setPayments(paymentData?.map((e, index) => {
                return {
                    Si: index + 1,
                    payment_id: e.id,
                    Name: e.customer_name,
                    Paidat: e.payment_date,
                    txnId: e.transaction_id,
                    payType: e.payment_method_name,
                    Amount:`${authState?.currency ?? "₹"}${e.paid_amount}`,
                    IndustryName: e.industry_name,
                    Status: e.payment_status,
                    Action:
                        <div>
                            <span>
                                <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToReciept(e.id) }}>Reciept</Btn>
                            </span>
                        </div >
                }
            }))
            setpaymentTotalRows(payment_api?.data?.total);
            setLoading(false)
        } else if (payment_api?.status >= 400 && payment_api.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (payment_api?.status >= 500 && payment_api.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);

        }
    }

    return (
        <>
         <Col sm="12" xl="6 xl-100">
                <Card>
                    <CardBody>
                        {PrimarycolorLineTab === '2' && (
                            <Dropdown className='ms-2' isOpen={dropdownOpen} toggle={toggleDropdown} style={{ float: 'right', marginRight: '10px' }}>
                                {/* <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                    {Export} <i className="icofont icofont-arrow-up"></i>
                                </DropdownToggle> */}
                                <DropdownMenu container="body">
                                    <DropdownItem style={toggleStyle} onClick={() => exportPaymentExcel()}><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => exportPaymentPdf()}><i className="fa fa-file-excel-o me-2"></i> Pdf</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        )}
                        <Nav className="border-tab nav-primary" tabs>
                            <NavItem>
                                <NavLink className={PrimarycolorLineTab === '1' ? 'active' : ''} style={{ cursor: 'pointer' }} onClick={() => setPrimarycolorLineTab('1')}>{Invoice}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={PrimarycolorLineTab === '2' ? 'active' : ''} style={{ cursor: 'pointer' }} onClick={() => setPrimarycolorLineTab('2')}>{Payment}</NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={PrimarycolorLineTab}>
                            <TabPane className="fade show" tabId="1">
                                <div className="order-history table-responsive" style={{ marginTop: '-15px' }}>
                                    <DataTable
                                        data={invoiceList}
                                        columns={InvoiceColumns}
                                        pagination
                                        progressPending={loading}
                                        paginationServer
                                        defaultSortAsc
                                        paginationTotalRows={totalRows}
                                        paginationDefaultPage={currentPage}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePageChange}
                                        // conditionalRowStyles={conditionalRowPayments}
                                        style={{ border: '1px solid' }}
                                    />
                                </div>
                            </TabPane>
                            <TabPane tabId="2">
                                <div className="order-history table-responsive" style={{ marginTop: '-15px' }}>
                                    <DataTable
                                        data={paymentslist}
                                        columns={paymentsColumns}
                                        pagination
                                        progressPending={loading}
                                        paginationServer
                                        defaultSortAsc
                                        paginationTotalRows={totalPaymentRows}
                                        paginationDefaultPage={currentPage}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePaymentPageChange}
                                        style={{ border: '1px solid' }}
                                    />
                                </div>
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </Col>
        </>
        
    );
};

export default InvoicePayment;
